type Fn<Arg, Res> = (arg: Arg) => Res;

// biome-ignore lint/suspicious/noExplicitAny: use `any` to allows chaining functions with varying input/output types
export function pipe<_Arg>(...fns: Fn<any, any>[]) {
	return async (initialInput: unknown) => {
		let context = initialInput;
		for (const fn of fns) {
			context = fn(context);
			if (context instanceof Promise) {
				context = await context;
			}
		}
		return context;
	};
}
